export default "__VITE_ASSET__CbDgkQBu__"